import { useHistory } from 'react-router-dom';
import I18n from 'i18n-js';

import { Divider } from '~/components/atoms/Divider';
import StyledButton, {
  EStyledButtonVariant,
} from '~/components/atoms/StyledButton';
import Image from '~/components/Image';

import heroImage from '~/popups/MenuPopup/assets/menu-hero.png';
import { LOGIN_PATH, REGISTER_PATHNAME } from '~/routes/paths';

import styles from './LoginHeader.module.scss';

interface ILoginHeader {
  replace?: boolean;
}

export default function LoginHeader({ replace }: ILoginHeader): JSX.Element {
  const history = useHistory();
  const link = history[replace ? 'replace' : 'push'];
  return (
    <>
      <div className={styles.heroImageContainer}>
        <Image
          alt=""
          src={heroImage}
          className={styles.heroImage}
          loading="eager"
          width={942}
          height={622}
        />
        <h1 className={styles.headline}>{I18n.t('common_claim')}</h1>
      </div>
      <section className={styles.loginActions}>
        <StyledButton
          variant={EStyledButtonVariant.GRAY}
          className={styles.loginButton}
          onClick={() => {
            link(LOGIN_PATH);
          }}
          role="link"
        >
          {I18n.t('common_login')}
        </StyledButton>
        <StyledButton
          variant={EStyledButtonVariant.BLUE}
          className={styles.loginButton}
          onClick={() => {
            link(REGISTER_PATHNAME);
          }}
          role="link"
        >
          {I18n.t('register')}
        </StyledButton>
      </section>
      <Divider className={styles.divider} />
    </>
  );
}
